module.exports = __webpack_public_path__ + "img/logo_top.d63a31c8.png";